import styled from 'styled-components';
import { H2 } from 'components/Typography';

export const Container = styled.div`
  text-align: center;
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  z-index: ${({ showServices }) => (showServices ? 2 : 0)};
`;

export const WelcomeContent = styled.div`
  opacity: ${({ isCollapsed }) => (isCollapsed ? '1' : '0')};
`;

export const CompanyName = styled(H2)`
  font-weight: 500;
`;

export const WelcomeMessage = styled.div`
  line-height: normal;
  padding: 20px 20px 10px;
  text-transform: uppercase;
  font-size: 0.75em;
  font-weight: 300;

  @media (min-width: 800px) {
    font-size: 0.875em;
  }
`;

export const WelcomeStyled = styled.div`
  height: ${({ isCollapsed }) => (isCollapsed ? 'auto' : '0')};
  border-radius: 0;
  width: 100%;
`;

export const BoarderContainer = styled.div`
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  position: fixed;
  width: 100%;
  left: 0;
  right: 0;
  align-self: flex-end;
`;

export const VenuesContent = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: ${({ isOrganisation }) => isOrganisation && '0'};
  width: ${({ isOrganisation }) => isOrganisation && '100%'};
`;

export const Venues = styled.section`
  display: block;
  padding: 0.1px 0 0;
  position: absolute;
  width: 100%;
`;

export const OfflineMessage = styled.div`
  text-align: center;
  padding: 0 20px 20px;
`;
